import * as React from 'react';
import * as brokerFirmActions from '../actions/BrokerFirmActions';
import * as BrokerTreeTypes from '../BrokerTreeTypes';
import notify from '../../../shared/feedback/notifications';
import { connect } from 'react-redux';
import {
    Modal,
    Button,
    FormControl,
    FormGroup,
    Form,
    ControlLabel,
    Checkbox,
    HelpBlock,
    Tab,
    Nav,
    NavItem,
    Table,
    Row,
    Col,
    Well
} from 'react-bootstrap';
import Select from 'react-select';
import { Translate } from '../../../shared/LanguageService';
import { assign } from '../../../shared/Assign';
import { handleError } from '../../../shared/ErrorCatching';
import FormInputChangeHandler from '../../../shared/form/FormInputChangeHandler';
import FormValidationService from '../../../shared/form/FormValidationService';
import ProductList from '../products/ProductList';
import FormSelect from '../../../components/common/FormSelect';
import FieldInfoIcon from '../../../components/common/FieldInfoIcon';
import CountryCodePhoneNumberInput from '../../../components/common/CountryCodePhoneNumberInput';
import OrderSourcesList from './OrderSourcesList';
import PlanSettingsForm from './PlanSettingsForm';
import ShowcaseSettings from './ShowcaseSettings';
import BrokersApi from '../BrokersApi';
import { BrokerFirmOtherInfo } from './BrokerFirmOtherInfo';
import * as Features from '../../../shared/Features';
import {
    CustomerAgreementTab,
    CustomerAgreementTabHandle
} from '../customerAgreements/CustomerAgreementTab';
import { BrokerFirmSalesInformation } from './BrokerFirmSalesInformation';

class FirmModal extends React.Component<any, any> {
    formInputChangeHandler: FormInputChangeHandler;

    customerAgreementTab = React.createRef<CustomerAgreementTabHandle>();

    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            firm: {
                type: BrokerTreeTypes.Firm,
                parentId: props.item.parentId,
                invoiceSellerStatus: 2,
                isActive: true,
                products: [],
                orderSources: [],
                brokerFirmPlanSettings: {},
                invoiceSummarySetting: true,
                name: '',
                highImageSize: undefined,
                highImageDpi: undefined,
                chainHighImageSize: undefined,
                chainHighImageDpi: undefined,
                highImageInherit: true,
                normalImageSize: undefined,
                normalImageDpi: undefined,
                normalImageAutoScale: undefined,
                normalImageSizeActive: false,
                chainNormalImageSize: undefined,
                chainNormalImageDpi: undefined,
                chainNormalImageAutoScale: undefined,
                chainNormalImageSizeActive: false,
                normalImageInherit: true,
                isForeignCountry: false,
                allowedToLetSE360Book: true,
                disallowCustomerToBook: false,
                procountorId: '',
                profileColor: '',
                profileLogo: null
            },
            image: {},
            imagePreviewUrl: '',
            invoiceBillingMethods: [],
            invoiceIntervals: [],
            orderSources: [],
            regions: [],
            customerTypes: [],
            photographer: '',
            errors: {},
            creating: false
        };

        this.closeModal = this.closeModal.bind(this);
        this.save = this.save.bind(this);
        this.updateProducts = this.updateProducts.bind(this);
        this.updateOrderSources = this.updateOrderSources.bind(this);
        this.setFirmState = this.setFirmState.bind(this);
        this.onPhotographerChange = this.onPhotographerChange.bind(this);
        this.addPhotographerToBlockList = this.addPhotographerToBlockList.bind(this);
        this.getAvailableBlockings = this.getAvailableBlockings.bind(this);
        this.removePhotographerFromBlockList = this.removePhotographerFromBlockList.bind(this);
        this.copyVisitorAddressToInvoice = this.copyVisitorAddressToInvoice.bind(this);
        this.updateArchiveSource = this.updateArchiveSource.bind(this);
        this.updateProfileColor = this.updateProfileColor.bind(this);
        this.handleLogoChange = this.handleLogoChange.bind(this);
        this.formInputChangeHandler = new FormInputChangeHandler(
            this.state.firm,
            this.setFirmState
        );
    }

    updateProfileColor(profileColor: string) {
        let firm = assign({}, this.state.firm);
        firm.profileColor = profileColor;
        this.formInputChangeHandler.updateObj(firm);
        this.setFirmState(firm);
    }

    handleLogoChange = (file) => {
        if (file) {
            let reader = new FileReader();
            reader.onloadend = () => {
                let firm = assign({}, this.state.firm);
                firm.profileLogo = file;
                this.setState({ profileLogo: file }, () => {});
                this.formInputChangeHandler.updateObj(firm);
                this.setFirmState(firm);
                let image = file;
                image.data = reader.result;
                this.setState({ image: image });
                BrokersApi.uploadBrokerFirmFile(this.state.firm.id, this.state.image);
            };
            reader.readAsArrayBuffer(file);
            let dataUrlreader = new FileReader();
            dataUrlreader.onloadend = () => {
                this.setState({ imagePreviewUrl: dataUrlreader.result });
            };
            dataUrlreader.readAsDataURL(file);
        } else {
            let firm = assign({}, this.state.firm);
            firm.profileLogo = file;
            this.setState({ profileLogo: null }, () => {});
            this.setState({ image: null });
            this.setState({ imagePreviewUrl: null });
            this.formInputChangeHandler.updateObj(firm);
            this.setFirmState(firm);
        }
    };

    setFirmState(newFirm: any) {
        this.setState({ firm: newFirm });
    }

    componentDidMount() {
        if (this.props.item.id > 0) {
            this.props.actions
                .editBrokerFirm(this.props.item.id)
                .then(() => {
                    let firm = assign(this.state.firm || {}, this.props.firm);
                    firm.chainHighImageSize = this.props.firm.chainHighImageSize;
                    firm.chainHighImageDpi = this.props.firm.chainHighImageDpi;
                    firm.highImageSize = this.props.firm.highImageSize;
                    firm.highImageDpi = this.props.firm.highImageDpi;
                    firm.highImageInherit = this.props.firm.highImageInherit;
                    firm.normalImageSize = this.props.firm.normalImageSize;
                    firm.normalImageDpi = this.props.firm.normalImageDpi;
                    firm.normalImageAutoScale = this.props.firm.normalImageAutoScale;
                    firm.normalImageSizeActive = this.props.firm.normalImageSizeActive;
                    firm.chainNormalImageSize = this.props.firm.chainNormalImageSize;
                    firm.chainNormalImageDpi = this.props.firm.chainNormalImageDpi;
                    firm.chainNormalImageAutoScale = this.props.firm.chainNormalImageAutoScale;
                    firm.chainNormalImageSizeActive = this.props.firm.chainNormalImageSizeActive;
                    firm.normalImageInherit = this.props.firm.normalImageInherit;
                    firm.preferHighImageDelivery = this.props.firm.preferHighImageDelivery;
                    firm.isForeignCountry = this.props.isForeignCountry;
                    firm.allowedToLetSE360Book = this.props.firm.allowedToLetSE360Book;
                    firm.showPrice = this.props.firm.showPrice;
                    firm.procountorId = this.props.firm.procountorId;
                    firm.profileColor = this.props.firm.profileColor;
                    firm.profileLogo = this.props.firm.profileLogo;
                    this.formInputChangeHandler.updateObj(firm);
                    this.setFirmState(firm);
                })
                .catch((error: any) => {
                    notify.failure(error);
                });
        } else {
            this.props.actions
                .newBrokerFirm(this.props.item.parentId)
                .then(() => {
                    if (this.props.selectedSeller !== null) {
                        let firm = assign({}, this.state.firm);
                        firm.chainHighImageSize = this.props.firm.chainHighImageSize;
                        firm.chainHighImageDpi = this.props.firm.chainHighImageDpi;
                        firm.highImageInherit = true;
                        firm.normalImageSize = undefined;
                        firm.normalImageDpi = undefined;
                        firm.normalImageAutoScale = undefined;
                        firm.normalImageSizeActive = false;
                        firm.chainNormalImageSize = this.props.firm.chainNormalImageSize;
                        firm.chainNormalImageDpi = this.props.firm.chainNormalImageDpi;
                        firm.chainNormalImageAutoScale = this.props.firm.chainNormalImageAutoScale;
                        firm.chainNormalImageSizeActive =
                            this.props.firm.chainNormalImageSizeActive;
                        firm.normalImageInherit = true;
                        firm.preferHighImageDelivery = this.props.firm.preferHighImageDelivery;
                        firm.brokerFirmPlanSettings = {
                            includeFreeFloorplansWithPhotoOrder:
                                this.props.includeFreeFloorplansWithPhotoOrderByDefault
                        };
                        firm.products = this.props.products;
                        firm.sellerId = this.props.selectedSellerId;
                        firm.orderSources = [];
                        firm.customerType = this.props.customerTypes[0]
                            ? this.props.customerTypes[0].id
                            : undefined;
                        firm.invoiceBillingMethod = this.props.invoiceBillingMethods[0]
                            ? this.props.invoiceBillingMethods[0].id
                            : undefined;
                        firm.invoiceIntervals = this.props.invoiceIntervals[0]
                            ? this.props.invoiceIntervals[0].value
                            : undefined;
                        firm.regionId = this.props.regions[0]
                            ? this.props.regions[0].id
                            : undefined;
                        firm.sellerId = this.props.sellers[0]
                            ? this.props.sellers[0].id
                            : undefined;
                        firm.isForeignCountry = this.props.isForeignCountry;
                        firm.allowedToLetSE360Book = true;
                        firm.showPrice = this.props.firm.showPrice;
                        firm.procountorId = this.props.procountorId;
                        firm.profileColor = this.props.firm.profileColor;
                        firm.profileLogo = this.props.firm.profileLogo;
                        this.formInputChangeHandler.updateObj(firm);
                        this.setFirmState(firm);
                    }
                })
                .catch((error: any) => {
                    notify.failure(error);
                });
        }
    }

    copyVisitorAddressToInvoice() {
        let firm = assign({}, this.state.firm);
        firm.invoiceAddress = firm.visitorAddress;
        firm.invoiceZip = firm.visitorZip;
        firm.invoiceCity = firm.visitorCity;
        this.formInputChangeHandler.updateObj(firm);
        this.setFirmState(firm);
    }

    render() {
        const showCustomerAgreement =
            FormValidationService.isEdit(this.props.item.id) &&
            Features.hasAnyFeature(
                [Features.ViewAssignedCustomerAgreements, Features.AssignCustomerAgreements],
                this.props.user
            );

        return (
            <Modal show={true} onHide={this.closeModal} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {FormValidationService.isEdit(this.props.item.id)
                            ? Translate('broker-firm/form/edit/title') +
                              (this.state.firm.name ? ': ' : ' ') +
                              this.state.firm.name
                            : Translate('broker-firm/form/create/title')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tab.Container defaultActiveKey={1} id="uncontrolled-tab">
                        <div>
                            <Nav>
                                <NavItem eventKey={1}>
                                    {Translate('broker-firm/form/tab/contact')}
                                    {FormValidationService.setTabValidationError(
                                        this.state.errors,
                                        'name',
                                        'organizationNumber',
                                        'contactPerson',
                                        'email',
                                        'telephone',
                                        'fax',
                                        'visitorAddress',
                                        'visitorZip',
                                        'visitorCity'
                                    )}
                                </NavItem>
                                <NavItem eventKey={2}>
                                    {Translate('broker-firm/form/tab/invoice')}
                                    {FormValidationService.setTabValidationError(
                                        this.state.errors,
                                        'invoiceName',
                                        'invoiceAddress',
                                        'invoiceZip',
                                        'invoiceCity',
                                        'invoiceEmail',
                                        'invoiceReference',
                                        'invoiceBillingMethod',
                                        'invoiceInterval',
                                        'invoicePaydays',
                                        'regionId',
                                        'invoiceSellerStatus'
                                    )}
                                </NavItem>
                                <NavItem eventKey={3}>
                                    {Translate('broker-firm/form/tab/account')}
                                    {FormValidationService.setTabValidationError(
                                        this.state.errors,
                                        'isActive',
                                        'isDemo',
                                        'salesInformation',
                                        'customerType',
                                        'sellerId'
                                    )}
                                </NavItem>
                                <NavItem eventKey={4}>
                                    {Translate('broker-firm/form/tab/more')}
                                    {FormValidationService.setTabValidationError(
                                        this.state.errors,
                                        'internalInformation',
                                        'photographerInformation',
                                        'deliveryWarning',
                                        'imageEditingInformation'
                                    )}
                                </NavItem>
                                <NavItem eventKey={5}>
                                    {Translate('broker-firm/form/tab/image-size')}
                                    {FormValidationService.setTabValidationError(
                                        this.state.errors,
                                        'highImageSize.size',
                                        'highImageSize.dpi',
                                        'highImageSize.autoScale',
                                        'normalImageSize.size',
                                        'normalImageSize.dpi',
                                        'normalImageSize.autoScale'
                                    )}
                                </NavItem>
                                <NavItem eventKey={6}>
                                    {Translate('broker-firm/tab/photographer-blocking')}
                                </NavItem>
                                <NavItem eventKey={7}>
                                    {Translate('broker-firm/form/tab/product-allocations')}
                                </NavItem>
                                <NavItem eventKey={8}>
                                    {Translate('broker-firm/form/tab/plan-settings')}
                                    {FormValidationService.setTabValidationError(
                                        this.state.errors,
                                        'brokerFirmPlanSettings.RoomSketcherKey'
                                    )}
                                </NavItem>
                                <NavItem eventKey={9}>
                                    {Translate('broker-firm/form/tab/integration')}
                                </NavItem>
                                <NavItem eventKey={10}>
                                    {Translate('broker-firm/form/tab/showcase')}
                                </NavItem>
                                {showCustomerAgreement && (
                                    <NavItem eventKey={11}>
                                        {Translate('broker-firm/form/tab/customer-agreement')}
                                    </NavItem>
                                )}
                            </Nav>
                            <Tab.Content>
                                <Tab.Pane eventKey={1}>
                                    <fieldset>
                                        <legend>{Translate('broker-firm/form/tab/contact')}</legend>
                                        <Form>
                                            <Row>
                                                <Col md={8}>
                                                    <FormGroup
                                                        className="required"
                                                        validationState={FormValidationService.getValidationState(
                                                            this.state.errors.name
                                                        )}
                                                    >
                                                        <ControlLabel>
                                                            {Translate('broker-firm/form/name')}
                                                        </ControlLabel>
                                                        <FormControl
                                                            autoFocus
                                                            type="text"
                                                            name="name"
                                                            value={
                                                                this.state.firm.name
                                                                    ? this.state.firm.name
                                                                    : ''
                                                            }
                                                            onChange={
                                                                this.formInputChangeHandler.onChange
                                                            }
                                                        />
                                                        <HelpBlock>
                                                            {this.state.errors.name}
                                                        </HelpBlock>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={4}>
                                                    <FormGroup
                                                        className="required"
                                                        validationState={FormValidationService.getValidationState(
                                                            this.state.errors.organizationNumber
                                                        )}
                                                    >
                                                        <ControlLabel>
                                                            {this.state.firm.isForeignCountry
                                                                ? Translate(
                                                                      'broker-firm/form/vat-number'
                                                                  )
                                                                : Translate(
                                                                      'broker-firm/form/organization-number'
                                                                  )}
                                                        </ControlLabel>
                                                        <FormControl
                                                            type="text"
                                                            name="organizationNumber"
                                                            value={
                                                                this.state.firm.organizationNumber
                                                                    ? this.state.firm
                                                                          .organizationNumber
                                                                    : ''
                                                            }
                                                            onChange={
                                                                this.formInputChangeHandler.onChange
                                                            }
                                                        />
                                                        <HelpBlock>
                                                            {this.state.errors.organizationNumber}
                                                        </HelpBlock>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <FormGroup
                                                className="required"
                                                validationState={FormValidationService.getValidationState(
                                                    this.state.errors.contactPerson
                                                )}
                                            >
                                                <ControlLabel>
                                                    {Translate('broker-firm/form/contact-person')}
                                                </ControlLabel>
                                                <FormControl
                                                    type="text"
                                                    name="contactPerson"
                                                    value={
                                                        this.state.firm.contactPerson
                                                            ? this.state.firm.contactPerson
                                                            : ''
                                                    }
                                                    onChange={this.formInputChangeHandler.onChange}
                                                />
                                                <HelpBlock>
                                                    {this.state.errors.contactPerson}
                                                </HelpBlock>
                                            </FormGroup>
                                            <FormGroup
                                                className="required"
                                                validationState={FormValidationService.getValidationState(
                                                    this.state.errors.email
                                                )}
                                            >
                                                <ControlLabel>
                                                    {Translate('broker-firm/form/email')}
                                                </ControlLabel>
                                                <FormControl
                                                    type="text"
                                                    name="email"
                                                    value={
                                                        this.state.firm.email
                                                            ? this.state.firm.email
                                                            : ''
                                                    }
                                                    onChange={this.formInputChangeHandler.onChange}
                                                />
                                                <HelpBlock>{this.state.errors.email}</HelpBlock>
                                            </FormGroup>
                                            <Row>
                                                <Col md={6}>
                                                    <FormGroup
                                                        validationState={FormValidationService.getValidationState(
                                                            this.state.errors.telephone
                                                        )}
                                                    >
                                                        <ControlLabel>
                                                            {Translate(
                                                                'broker-firm/form/telephone'
                                                            )}
                                                        </ControlLabel>
                                                        <FieldInfoIcon
                                                            title={Translate(
                                                                'popover/info/title/phonenumber'
                                                            )}
                                                            content={Translate(
                                                                'popover/info/content/phonenumber-mandatory'
                                                            )}
                                                        />
                                                        <CountryCodePhoneNumberInput
                                                            value={
                                                                this.state.firm.telephone
                                                                    ? this.state.firm.telephone
                                                                    : ''
                                                            }
                                                            onChange={(val) =>
                                                                this.formInputChangeHandler.onChange(
                                                                    {
                                                                        target: {
                                                                            name: 'telephone',
                                                                            value: val
                                                                        }
                                                                    }
                                                                )
                                                            }
                                                        />
                                                        <HelpBlock>
                                                            {this.state.errors.telephone}
                                                        </HelpBlock>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={6}>
                                                    <FormGroup
                                                        validationState={FormValidationService.getValidationState(
                                                            this.state.errors.fax
                                                        )}
                                                    >
                                                        <ControlLabel>
                                                            {Translate('broker-firm/form/fax')}
                                                        </ControlLabel>
                                                        <FormControl
                                                            type="text"
                                                            name="fax"
                                                            value={
                                                                this.state.firm.fax
                                                                    ? this.state.firm.fax
                                                                    : ''
                                                            }
                                                            onChange={
                                                                this.formInputChangeHandler.onChange
                                                            }
                                                        />
                                                        <HelpBlock>
                                                            {this.state.errors.fax}
                                                        </HelpBlock>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </fieldset>
                                    <fieldset>
                                        <legend>{Translate('broker-firm/form/tab/visitor')}</legend>
                                        <FormGroup
                                            className="required"
                                            validationState={FormValidationService.getValidationState(
                                                this.state.errors.visitorAddress
                                            )}
                                        >
                                            <ControlLabel>
                                                {Translate('broker-firm/form/visitor-address')}
                                            </ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="visitorAddress"
                                                value={
                                                    this.state.firm.visitorAddress
                                                        ? this.state.firm.visitorAddress
                                                        : ''
                                                }
                                                onChange={this.formInputChangeHandler.onChange}
                                            />
                                            <HelpBlock>
                                                {this.state.errors.visitorAddress}
                                            </HelpBlock>
                                        </FormGroup>
                                        <Row>
                                            <Col md={4}>
                                                <FormGroup
                                                    className="required"
                                                    validationState={FormValidationService.getValidationState(
                                                        this.state.errors.visitorZip
                                                    )}
                                                >
                                                    <ControlLabel>
                                                        {Translate('broker-firm/form/visitor-zip')}
                                                    </ControlLabel>
                                                    <FormControl
                                                        type="text"
                                                        name="visitorZip"
                                                        value={
                                                            this.state.firm.visitorZip
                                                                ? this.state.firm.visitorZip
                                                                : ''
                                                        }
                                                        onChange={
                                                            this.formInputChangeHandler.onChange
                                                        }
                                                    />
                                                    <HelpBlock>
                                                        {this.state.errors.visitorZip}
                                                    </HelpBlock>
                                                </FormGroup>
                                            </Col>
                                            <Col md={8}>
                                                <FormGroup
                                                    className="required"
                                                    validationState={FormValidationService.getValidationState(
                                                        this.state.errors.visitorCity
                                                    )}
                                                >
                                                    <ControlLabel>
                                                        {Translate('broker-firm/form/visitor-city')}
                                                    </ControlLabel>
                                                    <FormControl
                                                        type="text"
                                                        name="visitorCity"
                                                        value={
                                                            this.state.firm.visitorCity
                                                                ? this.state.firm.visitorCity
                                                                : ''
                                                        }
                                                        onChange={
                                                            this.formInputChangeHandler.onChange
                                                        }
                                                    />
                                                    <HelpBlock>
                                                        {this.state.errors.visitorCity}
                                                    </HelpBlock>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </fieldset>
                                </Tab.Pane>
                                <Tab.Pane eventKey={2}>
                                    <fieldset>
                                        <legend>{Translate('broker-firm/form/tab/invoice')}</legend>
                                        <fieldset>
                                            <legend>
                                                {Translate('broker-firm/form/invoice-address')}
                                            </legend>
                                            <Button
                                                bsStyle="default"
                                                onClick={this.copyVisitorAddressToInvoice}
                                            >
                                                {Translate(
                                                    'broker-firm/form/button/copy-visitor-address-to-invoice'
                                                )}
                                            </Button>
                                            <FormGroup
                                                className="required"
                                                validationState={FormValidationService.getValidationState(
                                                    this.state.errors.invoiceAddress
                                                )}
                                            >
                                                <ControlLabel>
                                                    {Translate('broker-firm/form/invoice-address')}
                                                </ControlLabel>
                                                <FormControl
                                                    type="text"
                                                    name="invoiceAddress"
                                                    value={
                                                        this.state.firm.invoiceAddress
                                                            ? this.state.firm.invoiceAddress
                                                            : ''
                                                    }
                                                    onChange={this.formInputChangeHandler.onChange}
                                                />
                                                <HelpBlock>
                                                    {this.state.errors.invoiceAddress}
                                                </HelpBlock>
                                            </FormGroup>
                                            <Row>
                                                <Col md={4}>
                                                    <FormGroup
                                                        className="required"
                                                        validationState={FormValidationService.getValidationState(
                                                            this.state.errors.invoiceZip
                                                        )}
                                                    >
                                                        <ControlLabel>
                                                            {Translate(
                                                                'broker-firm/form/invoice-zip'
                                                            )}
                                                        </ControlLabel>
                                                        <FormControl
                                                            type="text"
                                                            name="invoiceZip"
                                                            value={
                                                                this.state.firm.invoiceZip
                                                                    ? this.state.firm.invoiceZip
                                                                    : ''
                                                            }
                                                            onChange={
                                                                this.formInputChangeHandler.onChange
                                                            }
                                                        />
                                                        <HelpBlock>
                                                            {this.state.errors.invoiceZip}
                                                        </HelpBlock>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={8}>
                                                    <FormGroup
                                                        className="required"
                                                        validationState={FormValidationService.getValidationState(
                                                            this.state.errors.invoiceCity
                                                        )}
                                                    >
                                                        <ControlLabel>
                                                            {Translate(
                                                                'broker-firm/form/invoice-city'
                                                            )}
                                                        </ControlLabel>
                                                        <FormControl
                                                            type="text"
                                                            name="invoiceCity"
                                                            value={
                                                                this.state.firm.invoiceCity
                                                                    ? this.state.firm.invoiceCity
                                                                    : ''
                                                            }
                                                            onChange={
                                                                this.formInputChangeHandler.onChange
                                                            }
                                                        />
                                                        <HelpBlock>
                                                            {this.state.errors.invoiceCity}
                                                        </HelpBlock>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </fieldset>
                                        <Row>
                                            <Col md={6}>
                                                <FormGroup
                                                    className="required"
                                                    validationState={FormValidationService.getValidationState(
                                                        this.state.errors.invoiceName
                                                    )}
                                                >
                                                    <ControlLabel>
                                                        {Translate('broker-firm/form/invoice-name')}
                                                    </ControlLabel>
                                                    <FormControl
                                                        type="text"
                                                        name="invoiceName"
                                                        value={
                                                            this.state.firm.invoiceName
                                                                ? this.state.firm.invoiceName
                                                                : ''
                                                        }
                                                        onChange={
                                                            this.formInputChangeHandler.onChange
                                                        }
                                                    />
                                                    <HelpBlock>
                                                        {this.state.errors.invoiceName}
                                                    </HelpBlock>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup
                                                    className={
                                                        this.state.firm.invoiceBillingMethod === 1
                                                            ? 'required'
                                                            : ''
                                                    }
                                                    validationState={FormValidationService.getValidationState(
                                                        this.state.errors.invoiceEmail
                                                    )}
                                                >
                                                    <ControlLabel>
                                                        {Translate(
                                                            'broker-firm/form/invoice-email'
                                                        )}
                                                    </ControlLabel>
                                                    <FormControl
                                                        type="text"
                                                        name="invoiceEmail"
                                                        value={
                                                            this.state.firm.invoiceEmail
                                                                ? this.state.firm.invoiceEmail
                                                                : ''
                                                        }
                                                        onChange={
                                                            this.formInputChangeHandler.onChange
                                                        }
                                                    />
                                                    <HelpBlock>
                                                        {this.state.errors.invoiceEmail}
                                                    </HelpBlock>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <FormGroup
                                                    validationState={FormValidationService.getValidationState(
                                                        this.state.errors.invoiceReference
                                                    )}
                                                >
                                                    <ControlLabel>
                                                        {Translate(
                                                            'broker-firm/form/invoice-reference'
                                                        )}
                                                    </ControlLabel>
                                                    <FormControl
                                                        type="text"
                                                        name="invoiceReference"
                                                        value={
                                                            this.state.firm.invoiceReference
                                                                ? this.state.firm.invoiceReference
                                                                : ''
                                                        }
                                                        onChange={
                                                            this.formInputChangeHandler.onChange
                                                        }
                                                    />
                                                    <HelpBlock>
                                                        {this.state.errors.invoiceReference}
                                                    </HelpBlock>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup
                                                    className="required"
                                                    validationState={FormValidationService.getValidationState(
                                                        this.state.errors.invoiceSellerStatus
                                                    )}
                                                >
                                                    <ControlLabel>
                                                        {Translate(
                                                            'broker-firm/form/invoice-seller-status'
                                                        )}
                                                    </ControlLabel>
                                                    <FormSelect
                                                        name="invoiceSellerStatus"
                                                        value={
                                                            this.state.firm.invoiceSellerStatus
                                                                ? this.state.firm
                                                                      .invoiceSellerStatus
                                                                : ''
                                                        }
                                                        onChange={
                                                            this.formInputChangeHandler.onChange
                                                        }
                                                    >
                                                        {this.props.invoiceSellerStatuses.map(
                                                            (x: any) => {
                                                                return (
                                                                    <option value={x.id} key={x.id}>
                                                                        {Translate(x.name)}
                                                                    </option>
                                                                );
                                                            }
                                                        )}
                                                    </FormSelect>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <FormGroup
                                                    className="required"
                                                    validationState={FormValidationService.getValidationState(
                                                        this.state.errors.invoiceBillingMethod
                                                    )}
                                                >
                                                    <ControlLabel>
                                                        {Translate(
                                                            'broker-firm/form/invoice-billing-method'
                                                        )}
                                                    </ControlLabel>
                                                    <FormSelect
                                                        name="invoiceBillingMethod"
                                                        value={this.state.firm.invoiceBillingMethod}
                                                        onChange={
                                                            this.formInputChangeHandler.onChange
                                                        }
                                                    >
                                                        {this.props.invoiceBillingMethods.map(
                                                            (x: any) => {
                                                                return (
                                                                    <option value={x.id} key={x.id}>
                                                                        {Translate(x.name)}
                                                                    </option>
                                                                );
                                                            }
                                                        )}
                                                    </FormSelect>
                                                    <HelpBlock>
                                                        {this.state.errors.invoiceBillingMethod}
                                                    </HelpBlock>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup
                                                    className="required"
                                                    validationState={FormValidationService.getValidationState(
                                                        this.state.errors.invoicePaydays
                                                    )}
                                                >
                                                    <ControlLabel>
                                                        {Translate(
                                                            'broker-firm/form/invoice-paydays'
                                                        )}
                                                    </ControlLabel>
                                                    <FormControl
                                                        type="number"
                                                        name="invoicePaydays"
                                                        value={
                                                            this.state.firm.invoicePaydays
                                                                ? this.state.firm.invoicePaydays
                                                                : ''
                                                        }
                                                        onChange={
                                                            this.formInputChangeHandler.onChange
                                                        }
                                                    />
                                                    <HelpBlock>
                                                        {this.state.errors.invoicePaydays}
                                                    </HelpBlock>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <FormGroup
                                                    className="required"
                                                    validationState={FormValidationService.getValidationState(
                                                        this.state.errors.regionId
                                                    )}
                                                >
                                                    <ControlLabel>
                                                        {Translate('broker-firm/form/region')}
                                                    </ControlLabel>
                                                    <FormSelect
                                                        name="regionId"
                                                        value={this.state.firm.regionId}
                                                        onChange={
                                                            this.formInputChangeHandler.onChange
                                                        }
                                                    >
                                                        {this.props.regions.map((x: any) => {
                                                            return (
                                                                <option value={x.id} key={x.id}>
                                                                    {x.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </FormSelect>
                                                    <HelpBlock>
                                                        {this.state.errors.regionId}
                                                    </HelpBlock>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup
                                                    className="required"
                                                    validationState={FormValidationService.getValidationState(
                                                        this.state.errors.invoiceIntervals
                                                    )}
                                                >
                                                    <ControlLabel>
                                                        {Translate(
                                                            'broker-firm/form/invoice-interval'
                                                        )}
                                                    </ControlLabel>
                                                    <FormSelect
                                                        name="invoiceInterval"
                                                        value={this.state.firm.invoiceInterval}
                                                        onChange={
                                                            this.formInputChangeHandler.onChange
                                                        }
                                                    >
                                                        {this.props.invoiceIntervals.map(
                                                            (x: any) => {
                                                                return (
                                                                    <option
                                                                        key={x.value}
                                                                        value={x.value}
                                                                    >
                                                                        {Translate(x.displayName)}
                                                                    </option>
                                                                );
                                                            }
                                                        )}
                                                    </FormSelect>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6} className="no-label">
                                                <FormGroup>
                                                    <Checkbox
                                                        name="invoiceSummarySetting"
                                                        checked={
                                                            this.state.firm.invoiceSummarySetting
                                                        }
                                                        onChange={
                                                            this.formInputChangeHandler.onChange
                                                        }
                                                    >
                                                        <span>
                                                            {Translate(
                                                                'broker-firm/form/invoice-summary-setting'
                                                            )}
                                                        </span>
                                                    </Checkbox>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </fieldset>
                                </Tab.Pane>
                                <Tab.Pane eventKey={3}>
                                    <fieldset>
                                        <legend>{Translate('broker-firm/form/tab/account')}</legend>
                                        <Row>
                                            <Col md={2}>
                                                <FormGroup
                                                    validationState={FormValidationService.getValidationState(
                                                        this.state.errors.isActive
                                                    )}
                                                >
                                                    <Checkbox
                                                        name="isActive"
                                                        checked={
                                                            this.state.firm.isActive
                                                                ? this.state.firm.isActive
                                                                : false
                                                        }
                                                        onChange={
                                                            this.formInputChangeHandler.onChange
                                                        }
                                                    >
                                                        <span>
                                                            {Translate('broker-firm/form/is-active')}
                                                        </span>
                                                    </Checkbox>
                                                </FormGroup>
                                                <FormGroup
                                                    validationState={FormValidationService.getValidationState(
                                                        this.state.errors.isDemo
                                                    )}
                                                >
                                                    <Checkbox
                                                        name="isDemo"
                                                        checked={
                                                            this.state.firm.isDemo
                                                                ? this.state.firm.isDemo
                                                                : false
                                                        }
                                                        onChange={
                                                            this.formInputChangeHandler.onChange
                                                        }
                                                    >
                                                        <span>
                                                            {Translate('broker-firm/form/is-demo')}
                                                        </span>
                                                    </Checkbox>
                                                </FormGroup>
                                            </Col>
                                            <Col md={10}>
                                                <BrokerFirmSalesInformation
                                                    label={Translate(
                                                        'broker-firm/form/sales-information'
                                                    )}
                                                    salesInformation={
                                                        this.state.firm.salesInformation
                                                            ? this.state.firm.salesInformation
                                                            : ''
                                                    }
                                                    onChange={this.formInputChangeHandler.onChange}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <FormGroup
                                                    className="required"
                                                    validationState={FormValidationService.getValidationState(
                                                        this.state.errors.customerType
                                                    )}
                                                >
                                                    <ControlLabel>
                                                        {Translate(
                                                            'broker-firm/form/customer-type'
                                                        )}
                                                    </ControlLabel>
                                                    <FormSelect
                                                        name="customerType"
                                                        value={this.state.firm.customerType}
                                                        onChange={
                                                            this.formInputChangeHandler.onChange
                                                        }
                                                    >
                                                        {this.props.customerTypes.map((x: any) => {
                                                            return (
                                                                <option value={x.id} key={x.id}>
                                                                    {Translate(x.name)}
                                                                </option>
                                                            );
                                                        })}
                                                    </FormSelect>
                                                    <HelpBlock>
                                                        {this.state.errors.customerType}
                                                    </HelpBlock>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup
                                                    className="required"
                                                    validationState={FormValidationService.getValidationState(
                                                        this.state.errors.sellerId
                                                    )}
                                                >
                                                    <ControlLabel>
                                                        {Translate('broker-firm/form/seller')}
                                                    </ControlLabel>
                                                    <FormSelect
                                                        name="sellerId"
                                                        value={this.state.firm.sellerId}
                                                        onChange={
                                                            this.formInputChangeHandler.onChange
                                                        }
                                                    >
                                                        {this.props.sellers.map((x: any) => {
                                                            return (
                                                                <option value={x.id} key={x.id}>
                                                                    {x.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </FormSelect>
                                                    <HelpBlock>
                                                        {this.state.errors.sellerId}
                                                    </HelpBlock>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </fieldset>
                                </Tab.Pane>
                                <Tab.Pane eventKey={4}>
                                    <BrokerFirmOtherInfo
                                        labels={{
                                            fieldsetLegend: Translate('broker-firm/form/tab/more'),
                                            internalInfo: Translate(
                                                'broker-firm/form/internal-information'
                                            ),
                                            photographerInfo: Translate(
                                                'broker-firm/form/photographer-information'
                                            ),
                                            deliveryWarning: Translate(
                                                'broker-firm/form/delivery-warning'
                                            ),
                                            imageEditingInfo: Translate(
                                                'broker-firm/form/image-editing-information'
                                            ),
                                            imageEditorFirm: Translate(
                                                'broker-firm/form/image-editor-firm'
                                            ),
                                            editStyle: Translate('broker-firm/form/edit-style'),
                                            allowSE360ToBook: Translate(
                                                'broker-firm/form/allow-let-se360-book'
                                            ),
                                            disallowCustomerToBook: Translate(
                                                'broker-firm/form/disallow-customer-to-book'
                                            )
                                        }}
                                        onAnyChange={this.formInputChangeHandler.onChange}
                                        availableImageEditorFirms={
                                            this.props.availableImageEditorFirms
                                        }
                                        internalInformation={
                                            this.state.firm.internalInformation
                                                ? this.state.firm.internalInformation
                                                : ''
                                        }
                                        photographerInformation={
                                            this.state.firm.photographerInformation
                                                ? this.state.firm.photographerInformation
                                                : ''
                                        }
                                        deliveryWarning={
                                            this.state.firm.deliveryWarning
                                                ? this.state.firm.deliveryWarning
                                                : ''
                                        }
                                        imageEditingInformation={
                                            this.state.firm.imageEditingInformation
                                                ? this.state.firm.imageEditingInformation
                                                : ''
                                        }
                                        imageEditorFirmId={
                                            this.state.firm.imageEditorFirmId
                                                ? this.state.firm.imageEditorFirmId
                                                : ''
                                        }
                                        editStyleIdError={this.state.errors.editStyleId}
                                        editStyleId={
                                            this.state.firm.editStyleId
                                                ? this.state.firm.editStyleId
                                                : ''
                                        }
                                        availableEditStyles={this.props.editStyles}
                                        allowSE360ToBook={this.state.firm.allowedToLetSE360Book}
                                        disallowCustomerToBook={
                                            this.state.firm.disallowCustomerToBook
                                        }
                                    />
                                </Tab.Pane>
                                <Tab.Pane eventKey={5}>
                                    <fieldset>
                                        <legend>
                                            {Translate('broker-firm/form/tab/image-size')}
                                        </legend>
                                        <Table hover responsive>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        {Translate('image-size/table/header/name')}
                                                    </th>
                                                    <th>
                                                        {Translate(
                                                            'image-size/table/header/inherit'
                                                        )}
                                                    </th>
                                                    <th>
                                                        {Translate('image-size/table/header/size')}
                                                    </th>
                                                    <th>
                                                        {Translate('image-size/table/header/dpi')}
                                                    </th>
                                                    <th>
                                                        {Translate(
                                                            'image-size/table/header/auto-scale'
                                                        )}
                                                    </th>
                                                    <th>
                                                        {Translate(
                                                            'image-size/table/header/active'
                                                        )}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="label-cell">
                                                        <span className="label label-primary label-table">
                                                            {Translate('image-size/table/high')}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <Checkbox
                                                            name="highImageInherit"
                                                            checked={
                                                                this.state.firm.highImageInherit
                                                            }
                                                            onChange={
                                                                this.formInputChangeHandler.onChange
                                                            }
                                                        >
                                                            <span></span>
                                                        </Checkbox>
                                                    </td>
                                                    <td>
                                                        <FormGroup
                                                            validationState={FormValidationService.getValidationState(
                                                                this.state.errors['highImageSize']
                                                            )}
                                                        >
                                                            <FormControl
                                                                disabled={
                                                                    this.state.firm.highImageInherit
                                                                }
                                                                name="highImageSize"
                                                                type="number"
                                                                value={
                                                                    this.state.firm.highImageInherit
                                                                        ? this.state.firm
                                                                              .chainHighImageSize
                                                                        : this.state.firm
                                                                              .highImageSize
                                                                }
                                                                onChange={
                                                                    this.formInputChangeHandler
                                                                        .onChange
                                                                }
                                                            ></FormControl>
                                                            <HelpBlock>
                                                                {this.state.errors['highImageSize']}
                                                            </HelpBlock>
                                                        </FormGroup>
                                                    </td>
                                                    <td>
                                                        <FormGroup
                                                            validationState={FormValidationService.getValidationState(
                                                                this.state.errors['highImageDpi']
                                                            )}
                                                        >
                                                            <FormControl
                                                                disabled={
                                                                    this.state.firm.highImageInherit
                                                                }
                                                                name="highImageDpi"
                                                                type="number"
                                                                value={
                                                                    this.state.firm.highImageInherit
                                                                        ? this.state.firm
                                                                              .chainHighImageDpi
                                                                        : this.state.firm
                                                                              .highImageDpi
                                                                }
                                                                onChange={
                                                                    this.formInputChangeHandler
                                                                        .onChange
                                                                }
                                                            ></FormControl>
                                                            <HelpBlock>
                                                                {this.state.errors['highImageDpi']}
                                                            </HelpBlock>
                                                        </FormGroup>
                                                    </td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td className="label-cell">
                                                        <span className="label label-default label-table">
                                                            {Translate('image-size/table/normal')}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <Checkbox
                                                            name="normalImageInherit"
                                                            checked={
                                                                this.state.firm.normalImageInherit
                                                            }
                                                            onChange={
                                                                this.formInputChangeHandler.onChange
                                                            }
                                                        >
                                                            <span></span>
                                                        </Checkbox>
                                                    </td>
                                                    <td>
                                                        <FormGroup
                                                            validationState={FormValidationService.getValidationState(
                                                                this.state.errors['normalImageSize']
                                                            )}
                                                        >
                                                            <FormControl
                                                                disabled={
                                                                    this.state.firm
                                                                        .normalImageInherit ||
                                                                    !this.state.firm
                                                                        .normalImageSizeActive
                                                                }
                                                                name="normalImageSize"
                                                                type="number"
                                                                value={
                                                                    this.state.firm
                                                                        .normalImageInherit
                                                                        ? this.state.firm
                                                                              .chainNormalImageSize
                                                                        : this.state.firm
                                                                              .normalImageSize
                                                                }
                                                                onChange={
                                                                    this.formInputChangeHandler
                                                                        .onChange
                                                                }
                                                            ></FormControl>
                                                            <HelpBlock>
                                                                {
                                                                    this.state.errors[
                                                                        'normalImageSize'
                                                                    ]
                                                                }
                                                            </HelpBlock>
                                                        </FormGroup>
                                                    </td>
                                                    <td>
                                                        <FormGroup
                                                            validationState={FormValidationService.getValidationState(
                                                                this.state.errors['normalImageDpi']
                                                            )}
                                                        >
                                                            <FormControl
                                                                disabled={
                                                                    this.state.firm
                                                                        .normalImageInherit ||
                                                                    !this.state.firm
                                                                        .normalImageSizeActive
                                                                }
                                                                name="normalImageDpi"
                                                                type="number"
                                                                value={
                                                                    this.state.firm
                                                                        .normalImageInherit
                                                                        ? this.state.firm
                                                                              .chainNormalImageDpi
                                                                        : this.state.firm
                                                                              .normalImageDpi
                                                                }
                                                                onChange={
                                                                    this.formInputChangeHandler
                                                                        .onChange
                                                                }
                                                            ></FormControl>
                                                            <HelpBlock>
                                                                {
                                                                    this.state.errors[
                                                                        'normalImageDpi'
                                                                    ]
                                                                }
                                                            </HelpBlock>
                                                        </FormGroup>
                                                    </td>
                                                    <td>
                                                        <Checkbox
                                                            disabled={
                                                                this.state.firm
                                                                    .normalImageInherit ||
                                                                !this.state.firm
                                                                    .normalImageSizeActive
                                                            }
                                                            name="normalImageAutoScale"
                                                            checked={
                                                                this.state.firm.normalImageInherit
                                                                    ? this.state.firm
                                                                          .chainNormalImageAutoScale
                                                                    : this.state.firm
                                                                          .normalImageAutoScale
                                                            }
                                                            onChange={
                                                                this.formInputChangeHandler.onChange
                                                            }
                                                        >
                                                            <span></span>
                                                        </Checkbox>
                                                    </td>
                                                    <td className="tools">
                                                        <Checkbox
                                                            disabled={
                                                                this.state.firm.normalImageInherit
                                                            }
                                                            name="normalImageSizeActive"
                                                            checked={
                                                                this.state.firm.normalImageInherit
                                                                    ? this.state.firm
                                                                          .chainNormalImageSizeActive
                                                                    : this.state.firm
                                                                          .normalImageSizeActive
                                                            }
                                                            onChange={
                                                                this.formInputChangeHandler.onChange
                                                            }
                                                        >
                                                            <span></span>
                                                        </Checkbox>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        <ControlLabel>
                                            {Translate('image-size/prefer-high-image-delivery')}
                                        </ControlLabel>
                                        <Checkbox
                                            name="preferHighImageDelivery"
                                            checked={this.state.firm.preferHighImageDelivery}
                                            onChange={this.formInputChangeHandler.onChange}
                                        >
                                            <span></span>
                                        </Checkbox>
                                    </fieldset>
                                </Tab.Pane>
                                <Tab.Pane eventKey={6}>
                                    <fieldset>
                                        <legend>
                                            {Translate(
                                                'broker-firm/tab/photographer-blocking/form/legend/photographer-blocking'
                                            )}
                                        </legend>
                                        <div className="row">
                                            <div className="col-md-10">
                                                <ControlLabel>
                                                    {Translate(
                                                        'broker-firm/tab/photographer-blocking/form/select-label/photographers'
                                                    )}
                                                </ControlLabel>
                                                <Select
                                                    isMulti={false}
                                                    placeholder={Translate(
                                                        'broker-firm/tab/photographer-blocking/form/placeholder/select'
                                                    )}
                                                    noResultsText={Translate(
                                                        'broker-firm/tab/photographer-blocking/form/placeholder/no-results-found'
                                                    )}
                                                    value={
                                                        this.state.photographer
                                                            ? this.state.photographer
                                                            : ''
                                                    }
                                                    options={this.getAvailableBlockings(
                                                        this.props.photographers
                                                    )}
                                                    onChange={this.onPhotographerChange}
                                                />
                                            </div>
                                            <div className="col-md-2 no-label">
                                                <FormGroup>
                                                    <Button
                                                        bsStyle="primary"
                                                        disabled={this.state.photographer === ''}
                                                        onClick={this.addPhotographerToBlockList}
                                                    >
                                                        <i className="material-icons">add</i>{' '}
                                                        {Translate(
                                                            'broker-firm/tab/photographer-blocking/form/button-label/add'
                                                        )}
                                                    </Button>
                                                </FormGroup>
                                            </div>
                                        </div>
                                        <Table hover responsive>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        {Translate(
                                                            'broker-firm/tab/photographer-blocking/list/table-header/name'
                                                        )}
                                                    </th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.firm.photographerBlockings &&
                                                    this.state.firm.photographerBlockings.map(
                                                        (pb: any) => {
                                                            let photographer =
                                                                this.props.photographers.filter(
                                                                    (p: any) => pb === p.id
                                                                )[0];
                                                            return (
                                                                <tr key={photographer.id}>
                                                                    <td>{photographer.name}</td>
                                                                    <td>
                                                                        <FormGroup>
                                                                            <Button
                                                                                className="btn btn-sm pull-right"
                                                                                bsStyle="danger"
                                                                                onClick={() => {
                                                                                    this.removePhotographerFromBlockList(
                                                                                        photographer.id
                                                                                    );
                                                                                }}
                                                                            >
                                                                                <i className="material-icons">
                                                                                    delete{' '}
                                                                                </i>{' '}
                                                                                {Translate(
                                                                                    'broker-firm/tab/photographer-blocking/list/button-label/remove'
                                                                                )}
                                                                            </Button>
                                                                        </FormGroup>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                    )}
                                            </tbody>
                                        </Table>
                                    </fieldset>
                                </Tab.Pane>
                                <Tab.Pane eventKey={7}>
                                    <ProductList
                                        availableProductTypes={this.props.availableProductTypes}
                                        availableProducts={this.props.availableProducts}
                                        brokerTreeProductAllocationTypes={
                                            this.props.brokerTreeProductAllocationTypes
                                        }
                                        brokerTreeProductAllocationRequiredOptions={
                                            this.props.brokerTreeProductAllocationRequiredOptions
                                        }
                                        products={this.state.firm.products}
                                        update={this.updateProducts}
                                        showPrice={this.state.firm.showPrice}
                                        isEdit={this.props.item.id}
                                        onChange={this.formInputChangeHandler.onChange}
                                    />
                                </Tab.Pane>
                                <Tab.Pane eventKey={8}>
                                    <PlanSettingsForm
                                        availablePlanFirms={this.props.availablePlanFirms}
                                        availableExporterPlanTemplates={
                                            this.props.availableExporterPlanTemplates
                                        }
                                        availablePlanTemplates={this.props.availablePlanTemplates}
                                        onChange={this.formInputChangeHandler.onChange}
                                        brokerFirmPlanSettings={
                                            this.state.firm.brokerFirmPlanSettings
                                        }
                                        defaultPlanTemplateId={this.props.defaultPlanTemplateId}
                                        errors={this.state.errors}
                                    />
                                </Tab.Pane>
                                <Tab.Pane eventKey={9}>
                                    <OrderSourcesList
                                        availableOrderSources={this.props.orderSources}
                                        availableArchiveSources={this.props.archiveSources}
                                        archiveSource={this.state.firm.archiveSource}
                                        orderSources={this.state.firm.orderSources}
                                        update={this.updateOrderSources}
                                        updateArchiveSource={this.updateArchiveSource}
                                        onChange={this.formInputChangeHandler.onChange}
                                        procountorId={this.state.firm.procountorId}
                                    />
                                </Tab.Pane>
                                <Tab.Pane eventKey={10}>
                                    <ShowcaseSettings
                                        profileColor={this.state.firm.profileColor}
                                        onChange={this.formInputChangeHandler.onChange}
                                        updateProfileColor={this.updateProfileColor}
                                        profileLogo={this.state.firm.profileLogo}
                                        onFileChange={this.handleLogoChange}
                                        imagePreviewUrl={this.state.imagePreviewUrl}
                                        chainId={null}
                                        firmId={this.state.firm.id}
                                    />
                                </Tab.Pane>
                                {showCustomerAgreement && (
                                    <Tab.Pane eventKey={11}>
                                        {this.state.firm.id ? (
                                            <CustomerAgreementTab
                                                customer={{ kind: 'broker-firm', id: this.state.firm.id }}
                                                ref={this.customerAgreementTab}
                                                canAssign={Boolean(
                                                    Features.hasFeature(
                                                        Features.AssignCustomerAgreements,
                                                        this.props.user
                                                    )
                                                )}
                                            />
                                        ) : null}
                                    </Tab.Pane>
                                )}
                            </Tab.Content>
                        </div>
                    </Tab.Container>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col xs={2}>
                            <Well bsSize="small" className="pull-left">
                                <i>{this.props.item.brokerEntityId}</i>
                            </Well>
                        </Col>
                        <Col xs={10}>
                            <Button onClick={this.closeModal}>
                                {Translate('broker-firm/modal/footer/button-label/close')}
                            </Button>
                            <Button
                                disabled={this.state.creating}
                                bsStyle="primary"
                                onClick={this.save}
                            >
                                {Translate('broker-firm/modal/footer/button-label/save')}
                            </Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
        );
    }

    removePhotographerFromBlockList(id: any) {
        let firm = this.state.firm;
        let blockedPhotographers = firm.photographerBlockings;
        let filteredBlockedPhotographers = blockedPhotographers.filter((bp: any) => bp !== id);
        firm.photographerBlockings = filteredBlockedPhotographers;

        if (this.state.firm.id > 0) {
            let originalBlockings = this.props.firm.photographerBlockings;
            let exists = originalBlockings.filter((b: any) => b === id)[0];

            if (!firm.removedPhotographerBlockings) {
                firm.removedPhotographerBlockings = [];
            }

            if (exists) {
                firm.removedPhotographerBlockings.push(id);
            }
        }

        this.setState({ firm: firm });
    }

    addPhotographerToBlockList() {
        let firm = this.state.firm;
        if (!firm.photographerBlockings) {
            firm.photographerBlockings = [];
        }
        if (this.state.firm.id > 0 && firm.removedPhotographerBlockings) {
            firm.removedPhotographerBlockings = firm.removedPhotographerBlockings.filter(
                (b: any) => b !== this.state.photographer.value
            );
        }

        firm.photographerBlockings.push(this.state.photographer.value);
        this.setState({ photographer: '', firm: firm });
    }

    getAvailableBlockings(photographers: any) {
        let availablePhotographers: any = [];
        let photographerBlockings = this.state.firm.photographerBlockings;
        photographers.map((p: any) => {
            if (
                !photographerBlockings ||
                photographerBlockings.findIndex((pb: any) => pb === p.id) === -1
            ) {
                if (p.isRemoved === false) {
                    availablePhotographers.push({ value: p.id, label: p.name });
                }
            }
        });
        return availablePhotographers;
    }

    onPhotographerChange(value: any) {
        let photographer = this.state.photographer;
        photographer = value;
        this.setState({ photographer: photographer });
    }

    updateProducts(products: any[]) {
        let firm = assign({}, this.state.firm);
        firm.products = products;
        this.formInputChangeHandler.updateObj(firm);
        this.setFirmState(firm);
    }

    updateOrderSources(orderSources: any[]) {
        let firm = assign({}, this.state.firm);
        firm.orderSources = orderSources;
        this.formInputChangeHandler.updateObj(firm);
        this.setFirmState(firm);
    }

    updateArchiveSource(e: any) {
        let firm = assign({}, this.state.firm);
        let selectedArchiveSource = this.props.archiveSources.find(
            (x) => x.value == e.target.value
        );
        firm.archiveSource = selectedArchiveSource !== undefined ? selectedArchiveSource : null;
        this.formInputChangeHandler.updateObj(firm);
        this.setFirmState(firm);
    }

    save() {
        this.setState({ creating: true, errors: {} });
        let firm = assign({}, this.state.firm);

        if (firm.brokerFirmPlanSettings.overrideDefaultPlanTemplate === false) {
            firm.brokerFirmPlanSettings.planTemplateId = null;
        }

        if (firm.id > 0) {
            this.update(firm);
        } else {
            this.create(firm);
        }
    }

    create(firm) {
        this.props.actions
            .createBrokerFirm(firm)
            .then(() => {
                this.setState({ creating: false });
                notify.success(Translate('brokers/firm/create-message'));
                this.closeModal();
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    update(firm) {
        this.props.actions
            .updateBrokerFirm(firm.id, firm)
            .then(() =>
                this.customerAgreementTab.current
                    ? this.customerAgreementTab.current.save()
                    : true
            )
            .then((customerAgreementSaved: boolean) => {
                this.setState({ creating: false });
                if (customerAgreementSaved) {
                    notify.success(Translate('brokers/firm/edit-message'));
                }
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    closeModal() {
        this.props.onClose();
    }
}

function mapStateToProps(state: any) {
    return {
        user: state.user,
        firm:
            state.brokers && state.brokers.new && state.brokers.new.firm
                ? state.brokers.new.firm || {}
                : state.brokers.edit.firm || {},
        invoiceSellerStatuses: Array.isArray(state.brokers.new.invoiceSellerStatuses)
            ? state.brokers.new.invoiceSellerStatuses
            : Array.isArray(state.brokers.edit.invoiceSellerStatuses)
            ? state.brokers.edit.invoiceSellerStatuses
            : [],
        products: state.brokers.new.products,
        invoiceBillingMethods: Array.isArray(state.brokers.new.invoiceBillingMethods)
            ? state.brokers.new.invoiceBillingMethods
            : Array.isArray(state.brokers.edit.invoiceBillingMethods)
            ? state.brokers.edit.invoiceBillingMethods
            : [],
        invoiceIntervals: Array.isArray(state.brokers.new.invoiceIntervals)
            ? state.brokers.new.invoiceIntervals
            : Array.isArray(state.brokers.edit.invoiceIntervals)
            ? state.brokers.edit.invoiceIntervals
            : [],
        orderSources: Array.isArray(state.brokers.new.orderSources)
            ? state.brokers.new.orderSources
            : Array.isArray(state.brokers.edit.orderSources)
            ? state.brokers.edit.orderSources
            : [],
        archiveSources: Array.isArray(state.brokers.new.archiveSources)
            ? state.brokers.new.archiveSources
            : Array.isArray(state.brokers.edit.archiveSources)
            ? state.brokers.edit.archiveSources
            : [],
        customerTypes: Array.isArray(state.brokers.new.customerTypes)
            ? state.brokers.new.customerTypes
            : Array.isArray(state.brokers.edit.customerTypes)
            ? state.brokers.edit.customerTypes
            : [],
        regions: Array.isArray(state.brokers.new.regions)
            ? state.brokers.new.regions
            : Array.isArray(state.brokers.edit.regions)
            ? state.brokers.edit.regions
            : [],
        sellers: Array.isArray(state.brokers.new.sellers)
            ? state.brokers.new.sellers
            : Array.isArray(state.brokers.edit.sellers)
            ? state.brokers.edit.sellers
            : [],
        selectedSellerId: state.brokers.new.selectedSellerId
            ? state.brokers.new.selectedSellerId
            : undefined,
        photographers: Array.isArray(state.brokers.new.photographers)
            ? state.brokers.new.photographers
            : Array.isArray(state.brokers.edit.photographers)
            ? state.brokers.edit.photographers
            : [],
        availableProductTypes: Array.isArray(state.brokers.new.availableProductTypes)
            ? state.brokers.new.availableProductTypes
            : Array.isArray(state.brokers.edit.availableProductTypes)
            ? state.brokers.edit.availableProductTypes
            : [],
        availableProducts: Array.isArray(state.brokers.new.availableProducts)
            ? state.brokers.new.availableProducts
            : Array.isArray(state.brokers.edit.availableProducts)
            ? state.brokers.edit.availableProducts
            : [],
        brokerTreeProductAllocationTypes: Array.isArray(
            state.brokers.new.brokerTreeProductAllocationTypes
        )
            ? state.brokers.new.brokerTreeProductAllocationTypes
            : Array.isArray(state.brokers.edit.brokerTreeProductAllocationTypes)
            ? state.brokers.edit.brokerTreeProductAllocationTypes
            : [],
        brokerTreeProductAllocationRequiredOptions: Array.isArray(
            state.brokers.new.brokerTreeProductAllocationRequiredOptions
        )
            ? state.brokers.new.brokerTreeProductAllocationRequiredOptions
            : Array.isArray(state.brokers.edit.brokerTreeProductAllocationRequiredOptions)
            ? state.brokers.edit.brokerTreeProductAllocationRequiredOptions
            : [],
        availablePlanFirms: Array.isArray(state.brokers.new.availablePlanFirms)
            ? state.brokers.new.availablePlanFirms
            : Array.isArray(state.brokers.edit.availablePlanFirms)
            ? state.brokers.edit.availablePlanFirms
            : [],
        availableExporterPlanTemplates: Array.isArray(
            state.brokers.new.availableExporterPlanTemplates
        )
            ? state.brokers.new.availableExporterPlanTemplates
            : Array.isArray(state.brokers.edit.availableExporterPlanTemplates)
            ? state.brokers.edit.availableExporterPlanTemplates
            : [],
        availablePlanTemplates: Array.isArray(state.brokers.new.availablePlanTemplates)
            ? state.brokers.new.availablePlanTemplates
            : Array.isArray(state.brokers.edit.availablePlanTemplates)
            ? state.brokers.edit.availablePlanTemplates
            : [],
        defaultPlanTemplateId:
            state.brokers.edit.defaultPlanTemplateId !== undefined
                ? state.brokers.edit.defaultPlanTemplateId
                : state.brokers.new.defaultPlanTemplateId,
        editStyles: Array.isArray(state.brokers.new.editStyles)
            ? state.brokers.new.editStyles
            : Array.isArray(state.brokers.edit.editStyles)
            ? state.brokers.edit.editStyles
            : [],
        availableImageEditorFirms: Array.isArray(state.brokers.new.availableImageEditorFirms)
            ? state.brokers.new.availableImageEditorFirms
            : Array.isArray(state.brokers.edit.availableImageEditorFirms)
            ? state.brokers.edit.availableImageEditorFirms
            : [],
        isForeignCountry:
            state.brokers.edit.isForeignCountry !== undefined
                ? state.brokers.edit.isForeignCountry
                : state.brokers.new.isForeignCountry,
        profileColor: state.brokers.edit.profileColor
            ? state.brokers.edit.profileColor
            : state.brokers.new.profileColor,
        profileLogo: state.brokers.edit.profileLogo
            ? state.brokers.edit.profileLogo
            : state.brokers.new.profileLogo
        ,includeFreeFloorplansWithPhotoOrderByDefault:
            state.brokers.new.includeFreeFloorplansWithPhotoOrderByDefault !== undefined
                ? state.brokers.new.includeFreeFloorplansWithPhotoOrderByDefault
                : false
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            newBrokerFirm: (parentId: number) =>
                dispatch(brokerFirmActions.newBrokerFirm(parentId)),
            createBrokerFirm: (data: any) => dispatch(brokerFirmActions.createBrokerFirm(data)),
            editBrokerFirm: (id: number) => dispatch(brokerFirmActions.editBrokerFirm(id)),
            updateBrokerFirm: (id: number, firm: any) =>
                dispatch(brokerFirmActions.updateBrokerFirm(id, firm))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(FirmModal);
